import { forwardRef } from 'react';
import FullCalendar from '@fullcalendar/react';
import dayGridPlugin from '@fullcalendar/daygrid';
import timeGridPlugin from '@fullcalendar/timegrid';
import interactionPlugin from '@fullcalendar/interaction';
import itLocale from '@fullcalendar/core/locales/it';

const DEFAULT_HEADER = {
  left: 'prev,next today',
  center: 'title',
  right: 'dayGridMonth,timeGridWeek,timeGridDay',
};

/**
 * CalendarView — wrapper di `@fullcalendar/react` con plugin standard,
 * locale italiano e header toolbar di default.
 *
 * Plugin pre-caricati: `dayGrid`, `timeGrid`, `interaction`. Il consumer
 * può aggiungerne altri via `plugins` prop (vengono concatenati).
 *
 * Il ref viene inoltrato al `FullCalendar` sottostante per accedere
 * all'API imperativa (`getApi()`, `prev()`, `next()`, …).
 *
 * Tutte le altre props del FullCalendar sono passate attraverso (events,
 * eventClick, dateClick, slotDuration, businessHours, ecc.).
 */
const CalendarView = forwardRef(function CalendarView(
  {
    plugins = [],
    locale = itLocale,
    initialView = 'dayGridMonth',
    headerToolbar = DEFAULT_HEADER,
    height = 'auto',
    ...rest
  },
  ref
) {
  return (
    <FullCalendar
      ref={ref}
      plugins={[dayGridPlugin, timeGridPlugin, interactionPlugin, ...plugins]}
      locale={locale}
      initialView={initialView}
      headerToolbar={headerToolbar}
      height={height}
      {...rest}
    />
  );
});

export default CalendarView;
